import React from 'react';
import clsx from 'clsx';
// import { useSelector } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Button,
  makeStyles,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import DriveEtaRoundedIcon from '@material-ui/icons/DriveEtaRounded';

import Style from './Style';
import SearchVehicleComp from './SearchVehicleComp';

const useStyles = makeStyles((theme) => Style(theme));

export default function SearchVehicle({ toggle, setToggle }) {
  const classes = useStyles();

  // const vehicleInfo = useSelector(
  //   (state) => state.customerVehicleSearch?.vehicleInfo,
  // );
  const matchesMedia = useMediaQuery('(max-width:1400px)');

  return (
    <>
      <div className={clsx(classes.search__bar)}>
        <Button
          className={classes.search__btn}
          onClick={() => {
            setToggle(!toggle);
          }}
          style={{ width: matchesMedia && '70px' }}
        >
          <SearchIcon />
          {matchesMedia ? <DriveEtaRoundedIcon /> : 'Search Vehicle'}
          {!matchesMedia && <ExpandMoreIcon />}
        </Button>

        {toggle && (
          <div className={classes.dropdown__main}>
            <SearchVehicleComp setToggle={setToggle} />
          </div>
        )}
        <Typography className={clsx(classes.vehicle__text)}>
          {/* {vehicleInfo || ''} */}
        </Typography>
      </div>
    </>
  );
}
